"use client";
import { jsx } from "react/jsx-runtime";
import { instantiateObserver } from "../../../../utils/index.js";
import { useRef, useEffect } from "react";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const adObserver = (observer, observableElementRef) => {
  if (observableElementRef == null ? void 0 : observableElementRef.current) {
    observer.observe(observableElementRef.current);
  }
};
const AdMetricsObserver = ({
  intersectionThreshold = 0.5,
  observerTimeDelay = 1e3,
  onLoad,
  onView,
  children
}) => {
  const cardRef = useRef();
  useEffect(() => {
    let timer;
    if (onLoad) {
      onLoad();
    }
    const handleIntersect = (entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        timer = setTimeout(() => {
          if (onView) {
            onView();
          }
          observer.unobserve(entry.target);
        }, observerTimeDelay);
      } else {
        clearTimeout(timer);
      }
    };
    const observer = instantiateObserver(handleIntersect, {
      threshold: intersectionThreshold
    });
    adObserver(observer, cardRef);
    return () => {
      observer == null ? void 0 : observer.disconnect();
      clearTimeout(timer);
    };
  }, [intersectionThreshold, observerTimeDelay, onLoad, onView]);
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      ref: cardRef,
      sx: { display: "flex", flex: "1 1 auto", width: "100%" },
      children
    }
  );
};
export {
  AdMetricsObserver
};
